// src/contexts/NetworkContext.js
import React, { createContext, useContext } from 'react';
import useNetworkQuality from '../hooks/useNetworkQuality';

const NetworkContext = createContext({
  isSlow: false,
  isVerySlow: false,
  saveData: false,
  effectiveType: 'unknown',
  downlink: 10,
});

export const useNetwork = () => useContext(NetworkContext);

export const NetworkProvider = ({ children }) => {
  const network = useNetworkQuality();

  // 🆕 Ajoute une classe sur <html> pour le CSS global
  React.useEffect(() => {
    const html = document.documentElement;
    if (network.isVerySlow || network.saveData) {
      html.classList.add('connection-very-slow');
      html.classList.remove('connection-slow');
    } else if (network.isSlow) {
      html.classList.add('connection-slow');
      html.classList.remove('connection-very-slow');
    } else {
      html.classList.remove('connection-slow', 'connection-very-slow');
    }
  }, [network.isSlow, network.isVerySlow, network.saveData]);

  return (
    <NetworkContext.Provider value={network}>
      {children}
    </NetworkContext.Provider>
  );
};